import React from 'react';
import { Typography } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import { ReactComponent as RightHandle } from 'new/components/icons/handleRight.svg';
import classes from '../FlowNodes.module.scss';

interface CustomHandleProps {
  label?: string;
  handleId: string;
  color: string;
  isConnectable?: boolean;
  layoutDirection?: 'LR' | 'TB';
}

export const CustomHandle: React.FC<CustomHandleProps> = ({
  label,
  handleId,
  color,
  isConnectable = false,
  layoutDirection = 'LR',
}) => {
  const isTB = layoutDirection === 'TB';
  const position = isTB ? Position.Bottom : Position.Right;
  const style = isTB
    ? {
        position: 'absolute' as const,
        left: '50%',
        bottom: '-19px',
        transform: 'translateX(-50%)',
        width: '16px',
        height: '16px',
        background: 'transparent',
        border: 'none',
      }
    : {
        position: 'absolute' as const,
        top: '50%',
        right: '-19px',
        transform: 'translateY(-50%)',
        width: '16px',
        height: '16px',
        background: 'transparent',
        border: 'none',
      };

  return (
    <Typography variant="overline" style={{ position: 'relative' }}>
      {label}
      <Handle
        type="source"
        position={position}
        id={handleId}
        className={classes.handle_custom_svg}
        title={`Drag to create a new node`}
        isConnectable={isConnectable}
        style={style}
      >
        <RightHandle
          style={{
            fill: color,
            width: '16px',
            height: '16px',
          }}
        />
      </Handle>
    </Typography>
  );
};
